/* import __COLOCATED_TEMPLATE__ from './sq-input-money.hbs.js'; */
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import SqInputCurrencyComponent from '@dashboard/shared-ui/components/sq-input-currency';
import Money from '@square/dashboard-money/models/money';
let SqInputMoney = (_dec = computed('value.currencyCode'), _dec2 = computed('_placeholderOverride', 'currencyCode', 'formatter'), _class = class SqInputMoney extends SqInputCurrencyComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    _defineProperty(this, "onMoneyValueChange", () => {});
  }
  // This function overrides the function of the same name in sq-input-formatted.
  valueToStore(value) {
    if (isNone(value)) {
      return null;
    }
    let valueAsMoney;
    if (Money.detectInstance(value)) {
      valueAsMoney = value;
    } else {
      valueAsMoney = Money.fromCents(value, this.currencyCode);
    }
    return valueAsMoney;
  }
  get currencyCode() {
    return this.value?.currencyCode || Money.defaultCurrencyCode;
  }
  textFieldDidEndEditing() {
    super.textFieldDidEndEditing();
    this.onMoneyValueChange(this.value);
  }
  get placeholder() {
    if (this._placeholderOverride !== undefined) {
      return this._placeholderOverride;
    }
    return this.formatter.currency(0, this.currencyCode);
  }
  set placeholder(value) {
    set(this, '_placeholderOverride', value);
  }

  // This function overrides the function of the same name in sq-input-formatted.
  valueToShow(money) {
    if (Money.detectInstance(money) && money.isDefined()) {
      return money.get('amount');
    } else if (typeof money === 'number') {
      return money;
    } else {
      return null;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currencyCode", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currencyCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "placeholder", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "placeholder"), _class.prototype), _class);
export { SqInputMoney as default };